import { Button, TextField, TextareaAutosize, Typography } from '@mui/material'
import { textAreaStyle } from '../../constants/styleConstants'
import { ITestFiles } from '../../store/materials/types'
import CardTAG from '../CardTAG'
import LabelErrorTAG from '../LabelErrorTAG'

import AddIcon from '@mui/icons-material/Add'
import { ChangeEvent, Dispatch, SetStateAction } from 'react'
import utils from '../CaseInvestigation/utils'
import { useSelector } from 'react-redux'
import authSelectors from '../../store/auth/authSelectors'
import { uploadInputZones } from '../UploadDropzone/types'

interface IAdditionalMaterialCard {
  material: ITestFiles
  setNewMaterialFiles: (materialId: number, file: File) => any
  removeUnsavedFile: (materialId: number, file: File) => any
  setMaterialFilesToDelete: Dispatch<SetStateAction<{ id: number; files: string[] }[]>>
}

const AdditionalMaterialCard: React.FC<IAdditionalMaterialCard> = ({
  material,
  setNewMaterialFiles,
  removeUnsavedFile,
  setMaterialFilesToDelete,
}) => {
  const userEditAccess = useSelector(authSelectors.userReportEditAccess)
  const handleFileChange = (e: ChangeEvent<HTMLInputElement>) => {
    const file = e?.target?.files?.[0];

    //Prevent crash when user closes popup
    if (!file || !(file instanceof File)) {
      console.warn('User cancelled file upload — ignoring');
      return;
    }

    setNewMaterialFiles(material?.id, file);
  };


  const handleFileDelete = (test: any) => {
    setMaterialFilesToDelete(prev => {
      if (prev?.length === 0) {
        return [
          {
            id: material?.id,
            files: [test],
          },
        ]
      }

      const item = prev?.find(materialFiles => materialFiles?.id === material?.id)

      if (item) {
        return prev?.map(materialFiles => {
          if (materialFiles?.id === material?.id) {
            return {
              id: material?.id,
              files: [...materialFiles.files, test],
            }
          }
          return materialFiles
        })
      }

      return [...prev, { id: material?.id, files: [test] }]
    })
  }
  // const handleFileDelete = (file: any) => {
  //   // CASE 1: Saved file (has ID string)
  //   if (typeof file === 'string') {
  //     setMaterialFilesToDelete(prev => {
  //       const existing = prev.find(x => x.id === material.id);
  //       if (existing) {
  //         return prev.map(x =>
  //           x.id === material.id
  //             ? { ...x, files: [...x.files, file] }
  //             : x
  //         );
  //       }
  //       return [...prev, { id: material.id, files: [file] }];
  //     });
  //     return;
  //   }

  //   // CASE 2: Unsaved File object
  //   removeUnsavedFile(material.id, file);
  // };


  return (
    <CardTAG title={material.title} color='tagBoxMaterial'>
      {material.type === uploadInputZones.LINK && (
        <div className='t-field t-vbox'>
          <LabelErrorTAG label={'Link'} />
          <TextField value={material.link} disabled={!userEditAccess} />
        </div>
      )}
      {material.type !== uploadInputZones.LINK && (
        <div className='t-field t-vbox'>
          <LabelErrorTAG
            label={
              material.type === uploadInputZones.TEXT_FIELD ? 'Description' : 'Detailed Explanation'
            }
          />
          <TextareaAutosize
            value={material.description}
            readOnly
            minRows={5}
            style={textAreaStyle}
            disabled={!userEditAccess}
          />
        </div>
      )}
      {![uploadInputZones.TEXT_FIELD, uploadInputZones.LINK].includes(material.type) && (
        <>
          {utils.renderUploadedFiles([material] as any, handleFileDelete, !userEditAccess)}
          <Button
            component='label'
            variant='outlined'
            startIcon={<AddIcon />}
            sx={{ marginTop: '2.4rem' }}
            disabled={!userEditAccess}
          >
            <Typography sx={{ textAlign: 'center' }}>Upload File</Typography>
            <input
              onChange={handleFileChange}
              hidden
              multiple
              // accept='image/*'
              type='file'
              style={{
                width: '100%',
                height: '100%',
                borderRadius: '50%',
                backgroundColor: 'transparent',
                border: 'none',
              }}
            />
          </Button>
        </>
      )}
    </CardTAG>
  )
}

export default AdditionalMaterialCard
